import ScalarIconMoon_vue_vue_type_script_setup_true_lang_default from "./ScalarIconMoon.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconMoon.vue
var ScalarIconMoon_default = ScalarIconMoon_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconMoon_default as default };

//# sourceMappingURL=ScalarIconMoon.js.map